
import { getSpeciesHabitatGraph } from '@/services/data/graph-data.js'
import { defaultYAxis, credits, tickFontStyle, smallTickFontStyle } from '@/config/profile-config';
import { mergeDeep } from '@/lib/common';
import { offset } from 'highcharts';

export const loadData = async (tm, state, props, chartOptions, isLoaded) => {
  // get  data

  const data = await getSpeciesHabitatGraph(state.tsn, state.year, state.isSpecies);

  const axisGroup = {};
  const chart = { title: tm('profile.ABStatus.habHFAssociation.vegFewChart.yAxis') }
  const xAxis = [];
  const series = [];

  const values = data?.values;
  const categoryLookup = data?.category;
  const seriesCount = {};
  let nColumn = 0;
  /* first count how many data within each series */
  /*
  2022: also count the maximum main bar value, so when error bars are too big (e.g. 3x maxiumn main bar, don't display them,
  as it will make the main bars too short and create a big white space on the chart);
  2023: display all erorr bars regardless
  */
  let maxMainBar = -99999;
  values && values.forEach(row => {
    if (seriesCount[row.sId]) {
      seriesCount[row.sId]++;
    } else {
      seriesCount[row.sId] = 1;
    }
    if (row.isColumn) {
      nColumn++;
    }
    // track max main values
    if (row.isColumn && maxMainBar < row.mean) {
      maxMainBar = row.mean;
    }
  });
  maxMainBar *= 300;
  /* for each multiple data one, create 4 datasets (one column, two errorbars, spline), and assign to same sId, they will be display
    within same xAxis.
    for single data (one is veg type, the other is human footprint), for each create 2 dataset and assign to same category group,

    the loop below will create these xAxis groups
   */
  const dataName = [{ name: '', type: 'column', pointPlacement: 0 }, { name: 'errorbar', type: 'errorbar', pointPlacement: 0 }, { name: ' spline', type: 'spline', pointPlacement: 0.1, color: '#000' }, { name: ' other errorbar', type: 'errorbar', pointPlacement: 0.1, color: '#000' }];
  values.forEach(row => {
    /* key will be series Id for multiple, and series category for single */
    const key = seriesCount[row.sId] > 1 ? row.sId : categoryLookup.find(x => x.id === row.sId)?.category?.label;
    const pointWidth = seriesCount[row.sId] > 1 ? 10 : 15; /* make tree age group bar width smaller */
    /* initiate axisGroup if first encountered */
    if (!axisGroup[key]) {
      const axisOrder = Object.keys(axisGroup).length; // the index of the axis
      axisGroup[key] = { series: [], name: '', labels: [], order: axisOrder };
      // get current group label
      const currentLabel = (seriesCount[row.sId] > 1) ? categoryLookup.find(x => x.id === row.sId)?.label : categoryLookup.find(x => x.id === row.sId)?.category?.label;
      // push in 4 series for all
      dataName.forEach(x => axisGroup[key].series.push({ type: x.type, name: currentLabel + x.name, data: [], xAxis: axisOrder, pointPlacement: x.pointPlacement, pointWidth, color: x.color || null }));
      axisGroup[key].name = currentLabel;
      /* add color place holder for the main bar */
      if (seriesCount[row.sId] > 1) {
        axisGroup[key].series[0].color = categoryLookup.find(x => x.id === row.sId)?.color;
      } else {
        axisGroup[key].series[0].colors = [];
        axisGroup[key].series[0].colorByPoint = true;
      }
    }
    const label = axisGroup[key].labels;
    const groupData = axisGroup[key].series;
    /* set color: group with age categories, use same colors, groups with combined veg/hf bars each one has different colors */
    if (row.isColumn) { // only add category as columns, set color here
      if (seriesCount[row.sId] > 1) {
        label.push(row.treeSize);
      } else {
        label.push(categoryLookup.find(x => x.id === row.sId)?.label);
      }
      if (seriesCount[row.sId] === 1) { // for single dataset, user different colors for each
        axisGroup[key].series[0].colors.push(categoryLookup.find(x => x.id === row.sId)?.color);
      }
    }

    const startIndex = row.isColumn ? 0 : 2;
    /* when isColumn add main and main errorbar
      when is not column, add spline line, and another error bar

      don't show error bar, or spline dot when values are too large
    */
    /* use maxMain bar to hide too tall error bars */
    // groupData[startIndex + 1].data.push([(row.lower <= 0 || row.lower > maxMainBar) ? null : row.lower, (row.upper <= 0 || row.upper > maxMainBar) ? null : row.upper]);
    // groupData[startIndex].data.push(row.mean > maxMainBar ? null : row.mean);
    /* add all lower and upper regardless of their values: updated in 2023 */
    groupData[startIndex].data.push(row.mean);
    groupData[startIndex + 1].data.push([row.lower, row.upper]);
  });

  /* fro adding more space between axis */

  Object.keys(axisGroup).forEach(axisKey => {
    const axis = axisGroup[axisKey];
    /* for veg Type, and hf Type make them widee, but make the tre age group narrower */
    const reducePct = (axisKey.includes('Type') ? -10 : 4); /* 5 tree age group, 2 veg groups, options (-5, 2) (-7.5, 3) */
    axis.series.forEach(x => {
      if (x.data.length) { // add seires if not empty
        series.push(x)
      }
    });
    /* add x axis based on the number of columns, to adjust width */
    xAxis[axis.order] = {
      title:
      { text: axis.name, style: tickFontStyle },
      labels: { padding: 0, allowOverlap: true, reserveSpace: true, style: smallTickFontStyle },
      offset: 0, /* imporatant, this make sub axis align at same horizontal level */
      width: (100 * axis.series[0].data.length / nColumn - reducePct).toFixed(),
      categories: axis.labels,
      lineWidth: 1,
      lineColor: '#666'
    };
  })

  // set axis starting position
  let left = 0;
  xAxis.forEach(x => {
    /* make axis start 1% after it org space, and make the bars 1% smaller
    just to create space between groups */

    x.left = (left + 0.3) + '%';
    left += parseInt(x.width);
    x.width = (x.width - 0.3) + '%';
  });

  isLoaded.value++;
  const yAxis = mergeDeep(defaultYAxis, {
    title: {
      text: state.yUnit ?? chart.title,
      useHTML: true
    },

    reversedStacks: false
  });

  chartOptions.option = {
    credits,
    chart: {
      type: 'column',
      height: 500,
      events: {
        render: function () { // hide default legend
          // $('#' + divId + ' .highcharts-legend-item rect').attr('width', '0');
        }
      }
    },
    title: {
      text: '' // chart.title
    },
    legend: {
      enabled: false
    },
    xAxis,
    yAxis,
    plotOptions: {
      column: {
        stacking: 'normal',
        grouping: false,
        groupPadding: 0,
        shadow: false,
        dataLabels: {
          enabled: false
        }
      },
      errorbar: {
        whiskerWidth: 0
        // colors: '#666'
      },
      spline: {
        marker: {
          symbol: 'circle',
          fillColor: '#333',
          radius: 3
        },
        lineColor: '#333',
        lineWidth: 1
      },
      series: {
        dataLabels: {
          enabled: false
        }
      }
    },

    tooltip: {
      backgroundColor: '#FCFFC5',
      headerFormat: '',
      // for a series with mulitple year data: this.series.name => category name this.category.x => year this.y => value
      // for a series with grouped veg type data: this.category.name this.y
      pointFormatter: function () {
        if (!isNaN(Number(this.category.name))) {
          return this.series.name + ' Year ' + this.category.name + ': ' + this.y.toFixed(2) + '%';
        } else {
          return this.category.name + ': ' + this.y.toFixed(2) + '%';
        }
      }
      // pointFormat: `${point.name}: {point.y}%`
    },
    series: series,
    exporting: {
      enabled: true,
      width: 3000,
      scale: 3,
      chartOptions: {
        xAxis: xAxis.map(axis => ({
          ...axis,
          labels: {
            style: {
              fontSize: '5px',
            }
          },
          title: {
            style: {
              fontSize: '8px',
            },
            verticalAlign: 'bottom',
            offset: 0,
          }
        })),
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true, // Ensure data labels are enabled
            style: {
              fontSize: '2px' // Adjust the font size of the labels beneath each column (sub-labels)
            }
          }
        }
      },
    }
  };
}
